import { Module, GetterTree, ActionTree, MutationTree } from 'vuex'
import http from '@/http'

const state: QuestionNegativeRuleState = {
  questionNegativeRule: {
    condition_equation: '',
    replacement_text_key: '',
    flag: '',
    comment: '',
    conditions: [{
      source_type: 'question',
      source_key: '',
      matching_operator: '',
      matching_value: '',
    }],
  }
}

const getters: GetterTree<QuestionNegativeRuleState, RootState> = {
}

const actions: ActionTree<QuestionNegativeRuleState, RootState> = {
  create({ commit }, payload) {
    return http.v1.qnr.create(payload).then((response) => {
      commit('Question/ADD_QUESTION_NEGATIVE_RULE', response.data.data , { root: true })
      commit('SET_QUESTION_NEGATIVE_RULE', response.data.data)
      return response
    })
  },
  update({ commit }, { objectId, config }) {
    return http.v1.qnr.update(objectId, config).then((response) => {
      commit('Question/UPDATE_QUESTION_NEGATIVE_RULE', response.data.data , { root: true })
      return response
    })
  },
  delete({ commit }, { objectId }) {
    return http.v1.qnr.delete(objectId).then(() => {
      commit('Question/REMOVE_QUESTION_NEGATIVE_RULE', objectId, { root: true })
    })
  }
}

const mutations: MutationTree<QuestionNegativeRuleState> = {
  SET_QUESTION_NEGATIVE_RULE(state, payload) {
    state.questionNegativeRule = payload
  },
  CLEAR_STATE(state) {
    state.questionNegativeRule = {
      condition_equation: '',
      replacement_text_key: '',
      flag: '',
      comment: '',
      conditions: [{
        source_type: 'question',
        source_key: '',
        matching_operator: '',
        matching_value: '',
      }],
    }
  }
}

const anzsco: Module<QuestionNegativeRuleState, RootState> = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}

export default anzsco